import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { WdxButtonModule } from '@wdx/shared/components/wdx-button';
import { TranslateTokenisedStringPipe } from '@wdx/shared/utils';
import { WdxAlertListComponent } from './wdx-alert-list/wdx-alert-list.component';
import { WdxAlertComponent } from './wdx-alert.component';

@NgModule({
    imports: [CommonModule, WdxButtonModule, TranslateTokenisedStringPipe],
    declarations: [WdxAlertComponent, WdxAlertListComponent],
    exports: [WdxAlertComponent, WdxAlertListComponent],
})
export class WdxAlertModule {}
